import { BaseDto } from './base.dto';
import { User } from './user.dto';

export class BaseNote extends BaseDto {
  username?: string;
  content?: string;
  user?: User;
  entityId?: number;
}
